import React, { FC, useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  BillingSelfServePortal,
  PaymentFailureModal,
  PaymentProgressModal,
  PaymentSuccessModal,
} from 'components/organisms/module-settings/billing';

export enum PaymentStatuses {
  Processing = 'processing',
  Processed = 'processed',
  ProcessingFailed = 'processing-failed',
}

interface Props {
  paymentStatus?: PaymentStatuses;
  onPaymentStatusClosed: () => void;
  openSelfServePortalAfterFailure?: boolean;
}
export const PaymentStatus: FC<Props> = ({
  paymentStatus,
  onPaymentStatusClosed,
  openSelfServePortalAfterFailure = true,
}) => {
  const [loadPortal, setLoadPortal] = useState(false);

  const hideStatus = useCallback(() => {
    onPaymentStatusClosed();
  }, [onPaymentStatusClosed]);

  const onUpdateCard = useCallback(() => {
    onPaymentStatusClosed();
    if (openSelfServePortalAfterFailure) {
      setLoadPortal(true);
    }
  }, [onPaymentStatusClosed, openSelfServePortalAfterFailure]);

  const onPortalDismiss = useCallback(() => {
    setLoadPortal(false);
  }, []);

  return (
    <>
      {paymentStatus && (
        <>
          {paymentStatus === PaymentStatuses.Processing && (
            <PaymentProgressModal />
          )}
          {paymentStatus === PaymentStatuses.Processed && (
            <PaymentSuccessModal
              message={
                <FormattedMessage id="billing.invite.members.payment.success.content" />
              }
              onOk={hideStatus}
              onCancel={hideStatus}
            />
          )}
          {paymentStatus === PaymentStatuses.ProcessingFailed && (
            <PaymentFailureModal onOk={onUpdateCard} onCancel={hideStatus} />
          )}
        </>
      )}
      {loadPortal && <BillingSelfServePortal onDismiss={onPortalDismiss} />}
    </>
  );
};
